import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CFormInput,
  CButton,
} from "@coreui/react";

export const employees = [
  {
    id: 1,
    name: "Trần Viễn",
    code: "0KHOHCM042",
    phone: "0987654321",
    email: "tranvien@example.com",
    position: "CEO - Giám đốc điều hành",
    departmentId: 1,
    status: "active",
  },
  {
    id: 2,
    name: "Nguyễn Mai Phương",
    code: "0TLHCM042",
    phone: "0901234567",
    email: "maiphuong@example.com",
    position: "CTO",
    departmentId: 3,
    status: "active",
  },
  {
    id: 3,
    name: "Phan Ken",
    code: "0TLHCM061",
    phone: "0912345678",
    email: "phanken@example.com",
    position: "Giám đốc marketing",
    departmentId: 3,
    status: "active",
  },
];

export const TableExample = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredEmployees = employees.filter(
    (employee) =>
      employee.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      employee.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
      employee.phone.includes(searchTerm)
  );

  return (
    <div style={{ padding: "20px" }}>
      <h3>Danh sách nhân sự</h3>
      <div className="d-flex mb-3">
        <CFormInput
          type="text"
          placeholder="Tìm kiếm nhân sự..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="me-2"
        />
        <CButton color="success" variant="outline">
          Search
        </CButton>
      </div>

      <CTable striped hover responsive>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell>#</CTableHeaderCell>
            <CTableHeaderCell>Tên</CTableHeaderCell>
            <CTableHeaderCell>Mã</CTableHeaderCell>
            <CTableHeaderCell>Điện thoại</CTableHeaderCell>
            <CTableHeaderCell>Email</CTableHeaderCell>
            <CTableHeaderCell>Vị trí</CTableHeaderCell>
            <CTableHeaderCell>Trạng thái</CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {filteredEmployees.length > 0 ? (
            filteredEmployees.map((employee, index) => (
              <CTableRow key={employee.id}>
                <CTableDataCell>{index + 1}</CTableDataCell>
                <CTableDataCell>
                  <Link
                    to={`/nhan-su/${employee.id}`}
                    style={{ textDecoration: "none", color: "blue" }}
                  >
                    {employee.name}
                  </Link>
                </CTableDataCell>
                <CTableDataCell>{employee.code}</CTableDataCell>
                <CTableDataCell>{employee.phone}</CTableDataCell>
                <CTableDataCell>{employee.email}</CTableDataCell>
                <CTableDataCell>{employee.position}</CTableDataCell>
                <CTableDataCell>{employee.status}</CTableDataCell>
              </CTableRow>
            ))
          ) : (
            <CTableRow>
              <CTableDataCell colSpan="7" className="text-center">
                Không tìm thấy nhân sự nào!
              </CTableDataCell>
            </CTableRow>
          )}
        </CTableBody>
      </CTable>
    </div>
  );
};

export default TableExample;
